var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperless(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6274 15.7604C21.5458 13.9093 21.2805 11.7771 19.9132 10.1974L12.7532 1.88083C12.3541 1.41722 11.636 1.41745 11.2371 1.88131L4.08687 10.1974C2.71954 11.7771 2.45424 13.9093 3.37259 15.7604C4.29095 17.6115 6.20928 18.7551 8.36231 18.7551H11.301V22.3061C11.301 22.6893 11.6117 23 11.9949 23C12.3781 23 12.6888 22.6893 12.6888 22.3061V3.8978L17.2601 9.2185L15.403 10.9824C15.2704 11.1084 15.1989 11.2731 15.1989 11.4476C15.1989 11.622 15.2704 11.7868 15.403 11.9128C15.6785 12.1744 16.1173 12.1744 16.3826 11.9128L18.1377 10.2361L18.8213 11.0211C19.8417 12.2035 20.0458 13.8026 19.3519 15.1789C18.7295 16.4194 17.5152 17.2335 16.1173 17.3885V18.7163C18.0764 18.5515 19.7601 17.4467 20.6172 15.741L20.6274 15.7604ZM11.3112 17.437H8.37252C6.7603 17.437 5.33175 16.5744 4.63788 15.1982C3.94401 13.8123 4.14809 12.2229 5.16848 11.0405L5.90317 10.1877L11.3112 15.3242V17.4467V17.437ZM11.3112 13.4441L6.79091 9.15066L11.3112 3.8978V13.4441Z",
    fill: "#4A8D2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperless);
export default __webpack_public_path__ + "static/media/paperless.4fd9b81bd268817929164ef9f6f5d808.svg";
export { ForwardRef as ReactComponent };